import React from "react";
import { RichTextEditor } from "@/components/ui/RichTextEditor";
import { useFormContext } from "react-hook-form";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface InternalNotesStepProps {
  editorContent: string;
  onEditorContentChange: (value: string) => void;
}

export const InternalNotesStep: React.FC<InternalNotesStepProps> = () => {
  const { setValue, watch } = useFormContext();
  const notes = watch("notes") || {};

  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center gap-2 mb-2">
          <label htmlFor="internalNotes" className="block text-sm font-medium">
            Reason for purchase
          </label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Info className="h-4 w-4 text-muted-foreground cursor-help" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Internal notes from manager, not publicly visible</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <RichTextEditor
          value={notes.internalNotes || ""}
          onChange={(value) => {
            setValue("notes.internalNotes", value.trim());
          }}
        />
      </div>
    </div>
  );
};